/* eslint-disable eqeqeq */
import React from "react";
import { Row, Col } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import { HookFormInputGroup, HookFormRadioButton } from "components";
import { BillingStatusTypes, BillToTypes } from "types";
import { float6Normalizer } from "validators";
import { floatToSixValidation, currencySixSigns } from "validators/validation";

type BillToProps = {
	isLoading: boolean;
	isHandleChangeBillTo?: boolean;
	isReadOnlyAmountToBeBilled?: boolean;
	sectionName: string;
	billToName: string;
	amountToBeBilledName: string;
	index: number;
	defaultValue?: { [key: string]: any };
};

const BillTo = ({
	isLoading,
	sectionName,
	defaultValue,
	index,
	billToName,
	amountToBeBilledName,
	isHandleChangeBillTo = true,
	isReadOnlyAmountToBeBilled = false,
}: BillToProps) => {
	const {
		register,
		setValue,
		formState: { errors },
	} = useFormContext();

	const handleChangeBillTo = e => {
		const billToType = e.target.value;

		if (isHandleChangeBillTo) {
			if (
				billToType == BillToTypes.agent.value ||
				billToType == BillToTypes.merchant.value
			) {
				const v = BillingStatusTypes.pending;
				setValue(
					`${sectionName}.${index}.paymentTypeInfo.billingStatus`,
					v,
				);
			} else if (billToType == BillToTypes.aurora.value) {
				const v = BillingStatusTypes.billed_to_aurora;
				setValue(
					`${sectionName}.${index}.paymentTypeInfo.billingStatus`,
					v,
				);
			} else {
				setValue(
					`${sectionName}.${index}.paymentTypeInfo.billingStatus`,
					null,
				);
			}
		} else return;
	};

	return (
		<>
			<p>Bill To</p>
			<Row className="form-group">
				<Col md={2}>
					<HookFormRadioButton
						id={`${sectionName}.${index}.billToMerchant`}
						name={billToName}
						register={register}
						value={BillToTypes.merchant.value?.toString()}
						label={BillToTypes.merchant.displayName}
						onChange={handleChangeBillTo}
						blurLoading={isLoading}
					/>
				</Col>
				<Col md={2}>
					<HookFormRadioButton
						id={`${sectionName}.${index}.billToAgent`}
						name={billToName}
						register={register}
						value={BillToTypes.agent.value?.toString()}
						label={BillToTypes.agent.displayName}
						onChange={handleChangeBillTo}
						blurLoading={isLoading}
					/>
				</Col>
				<Col md={2}>
					<HookFormRadioButton
						id={`${sectionName}.${index}.billToAurora`}
						name={billToName}
						register={register}
						value={BillToTypes.aurora.value?.toString()}
						label={BillToTypes.aurora.displayName}
						onChange={handleChangeBillTo}
						blurLoading={isLoading}
					/>
				</Col>
			</Row>
			<Row className="form-group">
				<Col md={5}>
					<HookFormInputGroup
						name={amountToBeBilledName}
						register={register}
						label="Amount To Be Billed, $"
						colInput={6}
						colLabel={6}
						blurLoading={isLoading}
						autoComplete="off"
						placeholder="0.000000"
						showRequiredMark
						readOnly={isReadOnlyAmountToBeBilled}
						validator={{ floatToSixValidation }}
						normalize={currencySixSigns}
						normalizeOnBlur={float6Normalizer}
						defaultValue={defaultValue?.amountToBeBilled}
						errors={errors}
					/>
				</Col>
			</Row>
		</>
	);
};

export default BillTo;
